import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slices/userSlice';
import walletSlice from '../features/wallet/store/walletSlice';
import rewardsSlice from '../features/spin/store/rewardsSlice';
import progressSlice from '../features/spin/store/progressSlice';
import inventorySlice from '../features/inventory/store/inventorySlice';
import countersSlice from './slices/countersSlice';
import dailyRewardsSlice from '../features/rewards/store/dailyRewardsSlice';
import ticketsSlice from '../features/tickets/store/ticketsSlice';
import uiSlice from './slices/uiSlice';
import rewardsQueue from '../features/spin/store/rewardsQueueSlice';
import tonPaymentSlice from './slices/tonPaymentSlice';
import shopSlice from '../features/shop/store/shopSlice';
import characterSlice from '../features/inventory/store/characterSlice';
import datumPassSlice from '../features/datumPass/store/datumPassSlice';
import battlePassSlice from '../features/battlePass/store/battlePassSlice';
import lootboxSlice from '../features/lootbox/store/lootboxSlice';
import lairSlice from '../features/lair/store/lairSlice';
import legalSlice from '../features/legal/store/legalSlice';
import tutorialSlice from '../features/tutorial/store/tutorialSlice';
import inventoryNewSlice from '../features/inventory/store/inventoryNewSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    wallet: walletSlice,
    rewards: rewardsSlice,
    progress: progressSlice,
    inventory: inventorySlice,
    counters: countersSlice,
    dailyRewards: dailyRewardsSlice,
    tickets: ticketsSlice,
    ui: uiSlice,
    rewardsQueue,
    tonPayment: tonPaymentSlice,
    shop: shopSlice,
    characters: characterSlice,
    datumPass: datumPassSlice,
    battlePass: battlePassSlice,
    lootbox: lootboxSlice,
    lair: lairSlice,
    legal: legalSlice,
    tutorial: tutorialSlice,
    inventoryNew: inventoryNewSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
